import { useEffect, useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { message } from 'antd'
import { useAuth } from 'store/authStore/authStore'

const events = ['load', 'mousemove', 'mousedown', 'click', 'scroll', 'keypress']

export const useAutoLogout = () => {
    const { t } = useTranslation()

    const [{ isAuthenticated }, { logOut }] = useAuth()

    const timer = useRef<NodeJS.Timeout>()

    const autoLogoutTime = 1000 * 60 * 60 // 1 hour

    const handleLogoutTimer = () => {
        timer.current = setTimeout(() => {
            resetTimer()

            Object.values(events).forEach((item) => {
                window.removeEventListener(item, resetTimer)
            })

            if (isAuthenticated) {
                logOut()

                message.error({
                    content: t('auto_logout'),
                })
            }
        }, autoLogoutTime)
    }

    const resetTimer = () => {
        if (timer) clearTimeout(timer.current)
    }

    useEffect(() => {
        Object.values(events).forEach((item) => {
            window.addEventListener(item, () => {
                resetTimer()
                handleLogoutTimer()
            })
        })

        return () => {
            Object.values(events).forEach((item) => {
                window.removeEventListener(item, resetTimer)
            })

            resetTimer()
        }
    }, [isAuthenticated])

    return null
}
